import { isEntryOmitted, parsePiHeaderSlotItem } from '../../utils';

export const subNavEndPlugin = {
  beforeRender({ header, params, content, deviceType, locale }) {
    if (!header.subNavEnd) {
      header.subNavEnd = {
        type: '@sitebase/sub-nav-end',
        data: {
          id: 'kraken-sub-nav-end',
        },
        children: [],
      };
    }

    const isOmitted = isEntryOmitted(deviceType, locale);

    params.items
      .map((x) => parsePiHeaderSlotItem(x, { isOmitted, content }))
      .filter((x) => x)
      .forEach((x) => header.subNavEnd.children.push(x));
  },
};
